<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="120px" v-loading="loading">
        <el-row>
          <el-col :span="8">
            <el-form-item label="供应商名称">
              {{ formData.userName || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="保证金总额">
              {{ formData.depositAllChange || 0 }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="未锁定保证金">
              {{ formData.depositAfterChange || 0 }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="已锁定保证金">
              {{ calcLockedDeposit() }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="货款总额">
              {{ formData.goodsChange || 0 }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="可用货款">
              {{ formData.goodsAfterChange || 0 }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="已锁定货款">
              {{ calcLockedGoodsChange() }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="" label="付款方明细">
              <el-table size="mini" stripe border :data="payerData">
                <el-table-column min-width="180" label="采购方" prop="payerName"></el-table-column>
                <el-table-column min-width="120" label="保证金总额">
                  <template v-slot="{ row }">
                    <el-button type="text" @click="openFlowDialog(row, '1')">{{ row.depositAllChange || 0 }}</el-button>
                  </template>
                </el-table-column>
                <el-table-column min-width="120" label="未锁定保证金" prop="depositAfterChange"></el-table-column>
                <el-table-column min-width="120" label="已锁定保证金">
                  <template v-slot="{ row }">
                    {{ calcLockedDeposit(row) }}
                  </template>
                </el-table-column>
                <el-table-column min-width="120" label="可用货款" prop="goodsAfterChange"></el-table-column>
                <el-table-column min-width="120" label="货款总额">
                  <template v-slot="{ row }">
                    <el-button type="text" @click="openFlowDialog(row, '2')">{{ row.goodsChange || 0 }}</el-button>
                  </template>
                </el-table-column>
                <el-table-column min-width="120" label="已锁定货款">
                  <template v-slot="{ row }">
                    {{ calcLockedGoodsChange(row) }}
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>

    <el-dialog :title="flowDialogTitle" :visible.sync="flowDialogVisible" width="1020px">
      <div class="btn-between mb10">
        <span></span>
        <el-button type="primary" @click="onDownExcel">导出</el-button>
      </div>
      <el-table size="mini" stripe border v-loading="flowLoading" :data="flowData">
        <el-table-column show-overflow-tooltip min-width="160" label="流水编号" prop="transactionId"></el-table-column>
        <el-table-column min-width="230" label="关联单号" prop="oderNumber">
          <template v-slot="{ row }">
            <el-button v-if="flowType === '2'" type="text" @click="toDetail(row.oderNumber)">{{ row.oderNumber }}</el-button>
            <span v-else>{{ row.oderNumber }}</span>
            <el-button type="text" @click.stop="handleCopyText(row.oderNumber)">复制</el-button>
          </template>
        </el-table-column>
        <el-table-column min-width="120" :label="flowType === '1' ? '变动保证金' : '变动货款'" prop="amountChange"></el-table-column>
        <el-table-column min-width="140" label="变动原因" prop="changeReason"></el-table-column>
        <el-table-column min-width="120" label="变动方式">
          <template v-slot="{ row }">
            <span :class="{ 'text-success': row.amountType == '3', 'text-danger': row.amountType == '4' }">
              {{ amountTypeMap.get(row.amountType) || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="变动后余额">
          <template v-slot="{ row }">
            {{ ['1', '2'].includes(row.amountType) ? row.balanceAfterChange : row.balanceAllChange }}
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="flowPage" background layout="total, prev, pager, next"
        :total="flowTotal" @current-change="loadFlowData">
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import BigNumber from 'bignumber.js'
import { amountType } from '@/utils/dict'
import { copyText } from '@/utils/utils'
export default {
  name: 'UserBondDetail',
  components: {},
  data() {
    return {
      amountTypeMap: amountType,
      formData: {
        userId: '',
        userName: '',
        depositAllChange: '',
        depositChange: '',
        depositAfterChange: '',
        goodsChange: '',
        goodsAfterChange: ''
      },
      payerData: [],
      loading: false,
      flowDialogVisible: false,
      flowDialogTitle: '',
      flowType: '1',
      flowPayer: '',
      flowPage: 1,
      flowTotal: 0,
      flowData: [],
      flowLoading: false
    }
  },
  created() {
    if (this.userId) {
      this.loadData()
    }
  },
  computed: {
    userId() {
      return this.$route.query.userId
    }
  },
  methods: {
    // 复制文本
    async handleCopyText(text) {
      const success = await copyText(text)
      if (success) {
        this.$message.success('复制成功')
      } else {
        this.$message.error('复制失败，请手动复制')
      }
    },
    calcLockedDeposit(row = this.formData) {
      return new BigNumber(row.depositAllChange || 0)
        .minus(row.depositAfterChange || 0)
        .decimalPlaces(3)
        .toString()
    },
    calcLockedGoodsChange(row = this.formData) {
      return new BigNumber(row.goodsChange || 0)
        .minus(row.goodsAfterChange || 0)
        .decimalPlaces(3)
        .toString()
    },
    toDetail(orderNumber) {
      const loading = this.$loading({
        text: '加载中',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this.$axios.get(this.$apis.yxcDeliveryOrder.selectYxcPickupOrderByPickupNum, {
        pickupNumber: orderNumber
      }).then(res => {
        this.$router.push('/ycdeliveryOrder/detail?pickupId=' + res.pickupId)
      }).finally(() => {
        loading.close()
      })
    },
    openFlowDialog(row, type) {
      this.flowType = type
      this.flowPayer = row.payer
      this.flowPage = 1
      this.flowDialogTitle = `${row.payerName || '付款方'}-${type === '1' ? '保证金流水' : '货款流水'}`
      this.flowDialogVisible = true
      this.loadFlowData()
    },
    loadFlowData() {
      this.flowLoading = true
      this.$axios
        .get(this.$apis.yxcUserBond.selectYxcTransNewByPage, {
          userId: this.userId,
          payer: this.flowPayer,
          page: this.flowPage,
          size: 10,
          transactionType: this.flowType
        })
        .then(res => {
          this.flowData = res.list || []
          this.flowTotal = res.total || 0
        })
        .finally(() => {
          this.flowLoading = false
        })
    },
    onDownExcel() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })

      this.$axios
        .post(
          this.$apis.yxcUserBond.exportYxcDepositTransaction,
          {
            userId: this.userId,
            payer: this.flowPayer,
            transactionType: this.flowType
          },
          {
            responseType: 'blob'
          }
        )
        .then(res => {
          if (res) {
            const disposition = res.headers['content-disposition']
            const fileName = disposition
              .substring(disposition.indexOf('filename'))
              .split('=')[1]
            this.downloadFile(res.data, fileName)
          }
        })
        .catch(error => {
          console.error('导出失败:', error)
        })
        .finally(() => {
          loadingInstance.close()
        })
    },
    downloadFile(data, fileName) {
      const blob = new Blob([data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      window.URL.revokeObjectURL(href)
    },
    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.yxcUserBond.selectYxcUserDepositByDepositId, {
          params: { userId: this.userId }
        })
        .then(res => {
          const list = Array.isArray(res.list) ? res.list : (res ? [res] : [])
          this.payerData = list
          this.formData = this.getDepositSummary(list)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getDepositSummary(list) {
      const summary = {
        userId: this.userId,
        userName: list[0]?.userName || '',
        depositAllChange: '0',
        depositChange: '0',
        depositAfterChange: '0',
        goodsChange: '0',
        goodsAfterChange: '0'
      }
      const amountKeys = ['depositAllChange', 'depositChange', 'depositAfterChange', 'goodsChange', 'goodsAfterChange']
      amountKeys.forEach(key => {
        summary[key] = list.reduce((total, item) => {
          return total.plus(item[key] || 0)
        }, new BigNumber(0)).decimalPlaces(3).toString()
      })
      return summary
    }
  }
}
</script>

<style>
.text-success {
  color: #1eba1c;
  font-weight: bold;
}

.text-danger {
  color: #f54242;
  font-weight: bold;
}
</style>

<style scoped lang="scss">
.shoufa-form {
  width: 1200px;
}

::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.btn-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title-box {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 14px;
  margin-top: 10px;

  &:before {
    width: 3px;
    height: 14px;
    border-radius: 2px;
    background-color: $color-primary;
    position: absolute;
    top: 50%;
    left: 6px;
    content: "";
    transform: translateY(-50%);
  }
}
</style>
